import Vue from 'vue'
import Vuex from 'vuex'

import { authModule } from './auth'
import { editorModule } from './editor'
import { siteModule } from './site'
import { hintModule } from './hint'
import { articleModule } from './article'
import { debug } from '../util/log'

// Enable devtools on pascal
Vue.config.devtools = document.domain === 'ohm.dev.opoint.com'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: authModule,
    editor: editorModule,
    site: siteModule,
    hint: hintModule,
    article: articleModule
  },
  state: {
    initialized: false,  // if all modules have been initialized
    navbarText: '',

    // Currently selected hint statement for viewing its impact
    hintStatementImpact: null,

    // GET query parameters
    id_link: null,
    id_site: null,

    // Misc
    reclassifying: false,
  },
  mutations: {
    initialized(state, n) {
      debug("root store initialized")
      state.initialized = n
    },
    setIdSite(state, id_site) {
      state.id_site = id_site
    },
    setIdLink(state, id_link) {
      state.id_link = id_link
    },
    setSelectedStatementImpact(state, n) {
      state.hintStatementImpact = n
    },
    setReclassifying(state, n) {
      state.reclassifying = n
    }
  },
  actions: {
    init({ dispatch }, token) {
      debug("store init")
      return dispatch('auth/init', token)
    },
  }
})
